"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var color_1 = __importDefault(require("color"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var itemUtils_1 = require("../utils/itemUtils");
var ITEM_RENDERER_CLS = 'rct9k-item-renderer';
var ITEM_RENDERER_GLOW_CLS = 'rct9k-item-glow';
var WHITE_COLOR = (0, color_1.default)('white');
/**
 * Item (segment) renderer. All the properties of an item are copied as properties of this component. Hence the component
 * doesn't use the property `item`.
 *
 * All the properties have corresponding getter methods. We "OOP-ize" them, for the case where a subclass wants to "override" a property.
 * Without this pattern, such an override is not doable in React.
 * @extends React.Component<ItemRenderer.propTypes>
 */
var ItemRenderer = /** @class */ (function (_super) {
    __extends(ItemRenderer, _super);
    function ItemRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { string | JSX.Element }
     */
    ItemRenderer.prototype.getTitle = function () {
        return this.props.title;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { string }
     */
    ItemRenderer.prototype.getTooltip = function () {
        return this.props.tooltip;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { string | number }
     */
    ItemRenderer.prototype.getHeight = function () {
        return this.props.height;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { string }
     */
    ItemRenderer.prototype.getColor = function () {
        return this.props.color;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { number }
     */
    ItemRenderer.prototype.getGradientBrightness = function () {
        return this.props.gradientBrightness;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { number }
     */
    ItemRenderer.prototype.getGradientStop = function () {
        return this.props.gradientStop;
    };
    /**
     * Getter for the corresponding prop, to allow override by subclass.
     * @returns { boolean }
     */
    ItemRenderer.prototype.getGradientReverseDirection = function () {
        return this.props.gradientReverseDirection;
    };
    /**
     * Returns the color of the text. This method returns 'white' when the background is darker,
     * otherwise returns black.
     * @returns {string}
     */
    ItemRenderer.prototype.getTextColor = function () {
        return (0, color_1.default)(this.getColor()).isLight() ? 'black' : 'white';
    };
    /**
     * Create a linear gradient using the base color (calls getColor()) and a color obtained mixing
     * the white whit that color using getGradientBrightness(). The default order of the colors is
     * [brighter gradient color, gradient color]; this order can be reversed if getGradientReverseDirection() is true.
     *
     * By default, the background of an item uses a linear gradient, this method should be overriden if this behaviour is not wanted.
     * @returns {string} linear gradient
     */
    ItemRenderer.prototype.getBackgroundGradient = function () {
        var colors = [
            (0, color_1.default)(this.getColor())
                .mix(WHITE_COLOR, this.getGradientBrightness())
                .hex(),
            this.getColor()
        ];
        if (this.getGradientReverseDirection()) {
            colors.reverse();
        }
        return 'linear-gradient(' + colors[0] + ' ' + this.getGradientStop() + '%, ' + colors[1] + ')';
    };
    /**
     * Returns the style of the item.
     * @returns { object }
     */
    ItemRenderer.prototype.getStyle = function () {
        var style = __assign(__assign({}, this.props.style), { color: this.getTextColor(), height: this.getHeight(), background: this.getBackgroundGradient(), 
            /**
             * This was added as a workarround for: a blue line that appeared on top of the segments on Firefox:
             * https://redmine.xops-online.com/issues/31861?issue_count=43&issue_position=1&next_issue_id=31842
             */
            backgroundRepeat: 'no-repeat' });
        return style;
    };
    /**
     * Returns a css class used to apply glow on item hover.
     * @returns { string }
     */
    ItemRenderer.prototype.getGlowOnHoverClassName = function () {
        return this.props.glowOnHover ? ITEM_RENDERER_GLOW_CLS : '';
    };
    /**
     * Returns the css classes applied on the item.
     * @returns { string }
     */
    ItemRenderer.prototype.getClassName = function () {
        return ITEM_RENDERER_CLS + ' ' + this.props.className + ' ' + this.getGlowOnHoverClassName();
    };
    ItemRenderer.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("span", { className: this.getClassName(), style: this.getStyle(), title: this.getTooltip(), children: (0, jsx_runtime_1.jsx)("span", { className: "rct9k-item-renderer-inner", children: this.getTitle() }) }));
    };
    ItemRenderer.propTypes = {
        /**
         * It's passed by the parent. Though not used by this component. It exists because maybe subclasses want to use it.
         * @type { Item }
         */
        item: prop_types_1.default.object,
        /**
         * The title (label) of the segment (item).
         * @type { string }
         */
        title: prop_types_1.default.string,
        /**
         * Tooltip displayed on mouse over the segment (item).
         * @type { string }
         */
        tooltip: prop_types_1.default.string,
        /**
         * The height of the segment (item).
         *
         * This property is received from the parent and its based on `itemHeight` from `Timeline`. The parent adds a padding
         * (@see rct9k-items-inner class) which must be subtracted from `itemHeight` resulting in `height`.
         *
         * NOTE: If you override the getter, the maximum `height` can be `itemHeight` minus the padding.
         * @type { string | number }
         */
        height: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        /**
         * Used to show a glow effect around the segment (item) when the mouse is moved over the segment (item).
         * @type { boolean }
         */
        glowOnHover: prop_types_1.default.bool,
        /**
         * The renderer uses a **linear gradient** (top to bottom) as a background. The gradient is configured
         * using two colors: a base color (`color`) and the base color lightened by a percentage (`gradientBrightness`).
         * @type { string }
         */
        color: prop_types_1.default.string,
        /**
         * A number between 0 and 1; it represents the percentage by which `color` is lightened to obtain the second color used in the gradient.
         * @type { number }
         */
        gradientBrightness: prop_types_1.default.number,
        /**
         * A number between 0 and 100 (percentage from the height of the item) and it represents the point where the first color stops in the gradient.
         * @type { number }
         */
        gradientStop: prop_types_1.default.number,
        /**
         * Default order of the colors in the gradient: lighter color, base color.
         * If `true`, the order of the colors will be reversed.
         * @type { boolean }
         */
        gradientReverseDirection: prop_types_1.default.bool,
        /**
         * The style of the segment used to render the segment (item).
         * @type { object }
         */
        style: prop_types_1.default.object,
        /**
         * Class name used to render the segment (item).
         * @type { string }
         */
        className: prop_types_1.default.string
    };
    ItemRenderer.defaultProps = {
        color: '#3791D4',
        glowOnHover: true,
        gradientBrightness: 0.65,
        gradientStop: 40,
        gradientReverseDirection: false,
        title: undefined,
        tooltip: undefined,
        className: undefined,
        style: {},
        item: {}
    };
    return ItemRenderer;
}(react_1.default.Component));
exports.default = ItemRenderer;
//# sourceMappingURL=ItemRenderer.js.map